import { render, staticRenderFns } from "./StackingPlan.vue?vue&type=template&id=3c0db864&scoped=true"
import script from "./StackingPlan.vue?vue&type=script&lang=js"
export * from "./StackingPlan.vue?vue&type=script&lang=js"
import style0 from "./StackingPlan.vue?vue&type=style&index=0&id=3c0db864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0db864",
  null
  
)

export default component.exports